module.exports = __webpack_public_path__ + "img/IT0000452546040.7007169d.png";